import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import Paper from '@material-ui/core/Paper';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';

import Refresh from '../../../components/Refresh';
import {
  CALLCENTER_PLAN,
  dateToHtmlInputDate, getDateByDayId,
  restClient
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import Header from './Header';
import DatePickers from '../../../components/DatePickers';

const StyledNativeSelect = withStyles({
  select: {
    width: '173px'
  }
})(NativeSelect);

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [
        { name: 'Админ', id: 'administrator' },
        { name: 'ЮР Руководитель', id: 'company_admin' },
        { name: 'ЮР Менеджер', id: 'company_manager' },
        { name: 'КЦ Руководитель', id: 'callcenter_admin' },
        { name: 'КЦ Оператор', id: 'callcenter_manager' },
        { name: 'Админ ОКК', id: 'qcd_admin' }
      ],
      filter: {
        'date-from': getDateByDayId(-30).toISOString(),
        'date-to': getDateByDayId(0, true).toISOString(),
        user: 'all',
        search: 'login-rest'
      }
    };
  }

  getTitle() {
    return 'Лог';
  }

  onDateChangeFrom(evt) {
    const date = new Date(evt.target.value);
    date.setHours(0, 0, 0, 0);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-from': resultDate
      }
    });
  }

  onDateChangeTo(evt) {
    const date = new Date(evt.target.value);
    date.setHours(23, 59, 59, 999);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-to': resultDate,
      }
    });
  }

  onUserChange(evt) {
    this.setState({
      filter: {
        ...this.state.filter,
        user: evt.target.value,
      }
    });
  }

  onSearchChange(evt) {
    this.setState({
      filter: {
        ...this.state.filter,
        search: evt.target.value,
      }
    });
  }

  render() {

    return (
      <div className="col-wrapper">
        <Paper elevation={0} style={{ height: '44px', width: '890px', margin: '6px 0px 7px 10px' }}>
          <span style={{
            fontSize: '13px',
            fontWeight: '400',
            color: '#3a3a3a',
            marginLeft: '11px',
            marginRight: '7px',
            display: 'inline-block',
            top: '5px',
            position: 'relative'
          }}
          >
                С:
          </span>
          <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-from']))} onChange={this.onDateChangeFrom.bind(this)} style={{ top: '5px' }} />
          <span style={{
            fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '4px', position: 'relative'
          }}
          >По:
          </span>
          <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-to']))} onChange={this.onDateChangeTo.bind(this)} style={{ top: '5px' }} />
          <span style={{
            fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '4px', position: 'relative'
          }}
          >User:
          </span>
          <StyledNativeSelect
            value={this.state.filter.plan}
              onChange={this.onUserChange.bind(this)}
            style={{
              // marginLeft: '20px',
              top: '5px'
            }}
          >
            <option key="all" value="all">Все</option>
            {this.props.users.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
          </StyledNativeSelect>
          <span style={{
            fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '4px', position: 'relative'
          }}
          >Поиск:
          </span>
          <Input
            placeholder="192.168.0.1"
            name="search"
            onChange={this.onSearchChange.bind(this)}
            style={{
              // marginLeft: '20px',
              top: '5px'
            }}
            value={this.state.filter.search}
          />
        </Paper>
        <EjectedList
          {...this.props}
          title={this.getTitle()}
          sort={{ field: '_createdAt', order: SORT_DESC }}
          perPage={50}
          // actions={<Refresh />}
          bulkActions={false}
          style={{ width: '900px' }}
          headercomponent={Header}
          filter={this.state.filter}
        >
          <CustomerDatagrid
            // edit={edit}
            // create={create}
            roles={this.state.roles}
            companies={this.props.companies}
            callcenters={this.props.callcenters}
            users={this.props.users}
          />
        </EjectedList>
      </div>
    );
  }
}


export default connect(state => ({
  users: state.sc.users,
  companies: state.sc.companies,
  callcenters: state.sc.callcenters,
}), {})(List);



// WEBPACK FOOTER //
// ./src/pages/admin/requestlog/List.js